export const GET_BLUEPRINT = "GET_BLUEPRINT"
export const GET_BLUEPRINT_SUCCESS = "GET_BLUEPRINT_SUCCESS"
export const ADD_BLUEPRINT = "ADD_BLUEPRINT"
export const ADD_BLUEPRINT_SUCCESS = "ADD_BLUEPRINT_SUCCESS"
export const RESET_STORE_BLUEPRINT = "RESET_STORE_BLUEPRINT"
export const DELETE_BLUEPRINT = "DELETE_BLUEPRINT"
export const DELETE_BLUEPRINT_SUCCESS = "DELETE_BLUEPRINT_SUCCESS"
export const EDITLOAD_BLUEPRINT = "EDITLOAD_BLUEPRINT"
export const EDITLOAD_BLUEPRINT_SUCCESS = "EDITLOAD_BLUEPRINT_SUCCESS"